<template>
  <div class="detailWrap">
    <div class="detailMain">
      <div class="detailTitle">{{ userDetail.subtitle }} 获奖人</div>
      <detail :userDetail="userDetail" :winnerIco="winnerIco"></detail>
    </div>
    <footerbar></footerbar>
  </div>
</template>
<script>
import { getSignature } from "@/utils/wxShare";
import axios from "axios";
import detail from "@/components/detail/detail.vue";
import footerbar from "@/components/detail/footerbar.vue";
import { getUrlPara } from "@/assets/js/voteComm.js";
import { Toast } from "vant";

export default {
  name: "winner",
  components: {
    detail,
    footerbar,
  },
  data() {
    return {
      userDetail: {},
      urlId: "",
      winnerIco: true,
    };
  },
  methods: {
    //获取数据
    getDatalist() {
      let url = `/api/spec/share/userPrizewinnerDetail/${this.urlId}`;
      axios
        .get(url)
        .then((res) => {
          this.userDetail = res.data.data;
          this.userDetail.introduction = this.userDetail.introduction.replace(
            /[\n\r]/g,
            "<br>"
          );
          let dataForWeixin = {
            title: `${this.userDetail.username}正在第一视频参与投票，快来为他/她投一票吧！`,
            desc: this.userDetail.subtitle,
            imgUrl: this.userDetail.avatar,
          };
          // console.log(dataForWeixin);
          getSignature(dataForWeixin);
        })
        .catch((err) => {
          console.log(err);
          Toast.fail("请求错误，请联系管理员");
        });
    },
  },
  created() {
    this.urlId = getUrlPara("id");
    this.getDatalist();
  },
};
</script>
<style scoped>
</style>